import { render, staticRenderFns } from "./EmployeePriceList.vue?vue&type=template&id=23751090&"
import script from "./EmployeePriceList.vue?vue&type=script&lang=js&"
export * from "./EmployeePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports